import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import PostLoginLayout from "../components/layouts/PostLoginLayout";
import NotAuthorizedComponent from "../components/NotAuthorizedComponent";

const NotAuthorized = () => {
  const location = useLocation();

  let NotAuthorizedContainer = <NotAuthorizedComponent />;

  return <PostLoginLayout childComponent={NotAuthorizedContainer} noLeftPanel={false} loader={false}/>;
};

export default NotAuthorized;
